import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './en/translation';
import esTranslation from './es/translation';

import { STORAGE_KEYS } from '../constants/storageKeys';

// Get language from localStorage, browser, or default to 'en'
const getStoredLanguage = (): string => {
  if (typeof window === 'undefined') return 'en';

  // First, try to get from localStorage
  const storedLanguage = localStorage.getItem(`app-${STORAGE_KEYS.LANGUAGE}`);
  if (storedLanguage && (storedLanguage === 'en' || storedLanguage === 'es')) {
    return storedLanguage;
  }

  // If not in localStorage, detect browser language
  const browserLanguage = navigator.language || navigator.languages?.[0] || 'en';
  const languageCode = browserLanguage.split('-')[0].toLowerCase();

  // Map browser language to supported languages
  if (languageCode === 'es') {
    return 'es';
  }
  if (languageCode === 'en') {
    return 'en';
  }

  // Default to 'en' if browser language is not supported
  return 'en';
};

i18n.use(initReactI18next).init({
  lng: getStoredLanguage(),
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  resources: {
    en: { translation: enTranslation },
    es: { translation: esTranslation },
  },
});

export default i18n;
